import useAuthCore, { Config } from "./core/useAuthCore"

export const useAuth = () => {

    const config : Config  = {

    }
    return useAuthCore(config)
}